<template>
  <div id="card">
    <div id="sub-card">
      <img
        id="image"
        src="https://assets.website-files.com/5bff8886c3964a992e90d465/5c00fa3ad82b40e853c9952f_hero-3.svg"
        alt=""
      />
      <div
        id="sub-card-content"
        style="text-align: center; text-justify: center"
      >
        <div id="heading">{{ header }}</div>
        <div id="subheading">{{ subHeader }}</div>
        <div id="progress">
          <div id="progress-bar"></div>
        </div>
      </div>
    </div>

    <div id="card-actions">
      <div class="card-action">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="card-action">
              <v-icon
                v-bind="attrs"
                v-on="on"
                class="card-icon"
                size="30"
                color="white"
                @click="ctrl.delete(item)"
                >mdi-close</v-icon
              >
            </div>
          </template>
          <span>{{ deleteTt }}</span>
        </v-tooltip>
      </div>

      <div class="card-action">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="card-action">
              <v-icon
                v-bind="attrs"
                v-on="on"
                class="card-icon"
                size="30"
                color="white"
                @click="ctrl.onEdit(item)"
                >mdi-book-edit</v-icon
              >
            </div>
          </template>
          <span>{{ editTt }}</span>
        </v-tooltip>
      </div>

      <div v-if="onImageClick != null && onImageClick != undefined">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="card-action">
              <v-icon
                v-bind="attrs"
                v-on="on"
                class="card-icon"
                size="30"
                color="white"
                @click="onImageClick(item)"
                >mdi-square-edit-outline</v-icon
              >
            </div>
          </template>
          <span>{{ addContentTt }}</span>
        </v-tooltip>
      </div>

      <slot name="card-action" class="card-action"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    header: String,
    subHeader: String,
    onImageClick: Function,
    addContentTt: String,
    editTt: String,
    deleteTt: String,
    controller: String,
  },
  data() {
    return {
      ctrl: this.get_controller(this.controller),
    };
  },
};
</script>

<style>
#card {
  width: 100%;
  background: #efefef;
  border-radius: 30px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
  display: grid;
  grid-template-columns: 75% 25%;
}

#sub-card {
  height: 250px;
  width: 100%;
  background: #51cae9;
  border-radius: 30px;
  box-shadow: 3px 0px 6px rgba(0, 0, 0, 0.15);
  position: relative;
  text-align: center;
}

#image {
  width: 50%;
  margin-top: 30px;
}

#sub-card-content {
  height: 40%;
  width: 100%;
  background: rgba(26, 48, 54, 0.6);
  border-radius: 0px 0px 30px 30px;
  position: absolute;
  bottom: 0px;
  font-family: sans-serif;
  text-align: left;
  backdrop-filter: blur(2px);
}

#heading {
  font-size: 20px;
  padding: 15px;
  line-height: 20px;
  padding-bottom: 5px;
  color: white;
}

#subheading {
  font-size: 12px;
  line-height: 12px;
  padding: 15px;
  padding-top: 5px;
  padding-bottom: 15px;
  color: white;
}

#progress {
  height: 28px;
  margin-top: 10px;
  margin: 0px 15px;
  padding-bottom: 0px;
  background: #20505d;
  border-radius: 15px;
  position: relative;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
}

#progress-bar {
  background: #51cae9;
  height: 18px;
  width: 25%;
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 5px;
  position: absolute;
  border-radius: 15px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
}

#card-actions {
  padding-top: 20px;
  height: 250px;
  overflow: auto;
}

#card-actions::-webkit-scrollbar {
  border-radius: 20px;
  width: 0.3em;
}

#card-actions::-webkit-scrollbar-track {
  border-radius: 20px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

#card-actions::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background-color: #51cae9;
  border: 1px solid #306e7d;
  /* outline: 1px solid #306e7d; */
}

.card-action {
  text-align: center;
  height: 40px;
  width: 40px;
  background: #51cae9;
  margin: 0 auto;
  margin-bottom: 20px;
  border-radius: 50%;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.card-action:hover {
  background: #3ac1e2;
  box-shadow: 0px 5px 6px rgba(0, 0, 0, 0.15);
}

.card-action:active {
  background: #2e97b1;
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.15);
}

.card-icon {
  margin-top: 5px;
}
</style>